import { useRouter } from "vue-router";

export default function useAuthHelper() {
    const router = useRouter();

    const redirectIfAuthenticated = async () => {
        const isAuthenticated = JSON.parse(localStorage.getItem("isAuthenticated"));
        const isVerified = JSON.parse(localStorage.getItem("isVerified"));
        const isAgencyConfigured = JSON.parse(localStorage.getItem("isAgencyConfigured"));
        const isValidSubscription = JSON.parse(localStorage.getItem("isValidSubscription"));
        const isTrialExpired = JSON.parse(localStorage.getItem("isTrialExpired"));
        /*
         * redirect to Dashboard if
         * user is authenticated, email is verified, agency is configured, is valid subscription
         */
        if (isAuthenticated && isVerified && isAgencyConfigured && (isValidSubscription || !isTrialExpired)) {
            await router.push({ name: "dashboard", });
        }

        if (!isValidSubscription && isTrialExpired){
            await router.push({ name: "my-agencies", });
        }

        /*
         * redirect to Verify Email page if
         * user is authenticated, email is not verified
         */
        if (isAuthenticated && !isVerified) {
            await router.push({ name: "verify-email", });
        }

        /*
        * redirect to Agency Details page if
        * user is authenticated, email is verified and agency is not configured
        */
        if (isAuthenticated && isVerified && !isAgencyConfigured) {
            await router.push({ path: "/agency/agency-info", });
        }
    };

    return {
        redirectIfAuthenticated,
    };
}
